// Result Time Machine (cumulative party-votes-over-time timeline + playback).
// Same interim gating story as Result Audit: the menu item is surfaced via the
// already-granted ELECTION_RESULT_ANALYTICS code and the real gate is the
// module's inline live-JWT role check (Super Admin / Party Admin / Candidate),
// until a dedicated backend `result_time_machine` Action row is seeded, granted
// to the role, and the user re-logs. Swap the menu `roleActions` to
// [ACTIONS.RESULT_TIME_MACHINE] at that point.
export const ACTIONS_RESULT_TIME_MACHINE = {
	RESULT_TIME_MACHINE: 'result_time_machine',
	RESULT_TIME_MACHINE_VIEW: 'result_time_machine_view',
} as const;
